module.exports = __webpack_public_path__ + "static/media/header_customer_banner_mobile.ab203b95.svg";